import { Tooltip } from '@mui/material';
import React from 'react';

const VERSION = '1.0.5';
const PUBLISHED_DATE = '07/24/2026';
const CHANGELOG = [
  'Added new REBUILDS KPI category.',
  'Export a blank report template when a report has no data.',
  'Import KPI report data from Excel.',
  'Warn about unsaved changes in the report editor.',
];

const VersionTooltip = ({ color = 'white', style = {} }) => {
  return (
    <div style={style}>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.85)',
              color: 'white',
              fontSize: '13px',
              maxWidth: '300px',
              backdropFilter: 'blur(4px)',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)',
              borderRadius: '8px',
              padding: '10px',
            },
          },
        }}
        title={
          <div style={{ fontSize: '12px' }}>
            Published Date: {PUBLISHED_DATE}
            <ul
              style={{
                listStyleType: 'disc',
                paddingLeft: '20px',
              }}
            >
              {CHANGELOG.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        }
      >
        <span style={{ color }}>Version: {VERSION}</span>
      </Tooltip>
    </div>
  );
};

export default VersionTooltip;
